export default __webpack_public_path__ + "static/media/um.16ec8b7c.svg";